
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/standing_book/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeiSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeixinghao')">
            <el-input v-model="yt.conditions.modelCode"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'sort' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <!-- 设置上下限-->
            <el-button type="text" v-if="utils.checkPower('web_process_distribution_threshold_configuration_set')"
                       @click="yt.showEditDialog('setUpperLower', scope.row, '1200px')">
              {{$t('web_process_distribution_threshold_configuration_set')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog class="dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

      <!-- 设置上下限 -->
      <template v-if="yt.editObj.action == 'setUpperLower'">
<!--        <div class="dialog-scroller">-->
          <set-upper-lower ref="set_upper_lower"  :formLabelWidth="yt.formLabelWidth" :row="yt.editObj"  />
<!--        </div>-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="setUpperOrLower" :loading="yt.editObj.loading" type="primary">   {{ $t("baocun") }} </el-button>
        </span>
      </template>


    </el-dialog>
  </div>
</template>

<script>



import setUpperLower from './set_upper_lower.vue';


export default {
  name: 'web_process_distribution_threshold_configuration_list',
  components: {
    setUpperLower
  },
  data() {
    return {
      simpleOrgId: '',
      refreshOneKey: 0,
      refreshTwoKey: 0,
      equipmentIds: '',
      indexKey: null, // 高亮显示

      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'name',
          sort: 'string'

        },
        {
          label: 'shebeiSN',
          prop: 'sn',
          sort: 'string'

        },
        {
          label: 'shebeixinghao',
          prop: 'model.code',
          sort: 'string'
        },
        {
          label: 'shebeileixing',
          prop: 'typeId',
          type: 'dictionary',
          key: 'EQUIPMENT_TYPES'

        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'

        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 300,
          fixed: 'right'
        }

      ],

    };
  },


  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'sort'
      };
      this.yt.SELECT_URL = '/web/equipment/standing_book/getEquipmentByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      // this.getOrganizationList()
    }, 300);
  },
  methods: {
// 保存上下限参数
    setUpperOrLower() {
      this.yt.editObj.loading = true;
      this.$refs["set_upper_lower"].$refs["form"]
        .validate((valid) => {
        if (valid) {
          const params = this.$refs["set_upper_lower"].form;
          if(!params.datas || params.datas.length == 0){
            return;
          }
          return this.http.post("/web/craft/threshold_configuration/batchInsert", params)
            .then((response) => {
              this.yt.isShowEditDialog = false;
              this.yt.get(1);
            }) .catch((error) => {
              this.yt.editObj.loading = false;
              this.$message.error(error);
            });
        }
      }).finally(() => {
        this.yt.editObj.loading = false;
      });
    },



    handleSelectionChange(section, value) {
      let res = this.multipleSelection.filter(item => {
        return item.id == value.id;
      });
      if (res.length > 0) {
        this.multipleSelection = this.multipleSelection.filter(item => {
          return item.id != value.id;
        });
      } else {
        this.multipleSelection.push(value);
      }
    },
    // 关闭tag标签
    closeTag(id) {
      this.multipleSelection = this.multipleSelection.filter(item => {
        return item.id != id;
      });
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          if (ids.indexOf(row.id) == -1) {
            this.$refs.table.toggleRowSelection(row, false);
          }
        });
      });
    },
    // 监听分页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getStandingBook();
    },
    // 搜索
    searchStandingBook() {
      this.pageNum = 1;
      this.getStandingBook();
    },
    // 重置
    reset() {
      this.pageNum = 1;
      this.queryParam = {};
      this.getStandingBook();
    },
    // 获取设备列表
    async getStandingBook() {
      let param = Object.assign(
        {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        },
        this.queryParam
      );
      let response = await this.http.get('/web/equipment/standing_book/page', {
        params: param
      });
      if (response.code == 200) {
        this.total = response.data.total;
        this.tableData = response.data.rows;
        /*this.$nextTick(() => {
          this.tableData.forEach(row => {
            let ids = this.multipleSelection.map(item => {
              return item.id;
            });
            if (ids.indexOf(row.id) >= 0) {
              this.$refs.table.toggleRowSelection(row, true);
            }
          });
        });*/
      }
    },

  }
};
</script>


<style scoped="scoped" lang="scss">
  ._form /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    // height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100px;
  }

  ._formItem /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    // height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 80px;
  }

  ._form /deep/ .el-input__icon {
    content: '';
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
    margin-left: -220px;
  }

  ._form /deep/ .el-select {
    min-width: 80px;

    .el-select-dropdown {
      .el-scrollbar {
        .el-select-dropdown__wrap {
          .el-scrollbar__view {
            .el-select-dropdown__item:hover {
            }
          }
        }
      }
    }
  }
</style>
